module.exports = __webpack_public_path__ + "image/daifadan.48aef42.png";